import { IEntity } from "./Entity";

export interface IRiskAppEvidence extends IEntity {
    FileUniqueID?: string;
    Details?: string;
    IssueID?: number;
    IssueActionID?: number;
    IncidentID?: number;
    IncidentActionID?: number;
    RiskID?: number;
    RiskMitigationActionID?: number;
    DateCreated?: Date;
    AddedByUserID?: number;
    AttachmentType?: string;
}

export class RiskAppEvidence implements IRiskAppEvidence {
    public ID: number = 0;
    public Title: string = null;
    public FileUniqueID?: string = null;
    public Details?: string = "";
    public IssueID?: number = null;
    public IssueActionID?: number = null;
    public IncidentID?: number = null;
    public IncidentActionID?: number = null;
    public RiskID?: number = null;
    public RiskMitigationActionID?: number = null;
    public DateCreated?: Date = null;
    public AddedByUserID?: number = null;
    public AttachmentType?: string = null;

    constructor(
        issueID: number,
        issueActionID: number,
        incidentID: number,
        incidentActionID: number,
        riskID: number,
        riskMitigationActionID: number,
        attachmentType: string
    ) {
        this.IssueID = issueID;
        this.IssueActionID = issueActionID;
        this.IncidentID = incidentID;
        this.IncidentActionID = incidentActionID;
        this.RiskID = riskID;
        this.RiskMitigationActionID = riskMitigationActionID;
        this.AttachmentType = attachmentType;
    }
}